/** Matches synthetic emails from POST /influencers/roster (potentials without a real address). */
export const SYNTHETIC_INFLUENCER_EMAIL_DOMAIN = 'placeholder.invalid'

export function isSyntheticInfluencerEmail(email) {
  if (email == null || email === '') return true
  return String(email).trim().toLowerCase().endsWith(`@${SYNTHETIC_INFLUENCER_EMAIL_DOMAIN}`)
}

/** True when a real platform invite / campaign invite email can be sent. */
export function isValidPlatformInviteEmail(email) {
  const e = String(email ?? '').trim().toLowerCase()
  if (!e || isSyntheticInfluencerEmail(e)) return false
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return false
  return true
}
